import React, { FC } from 'react';
import PolygonItem, { PolygonItemType } from '../polygon-card/polygon-item';
import { POLYGON_COLORS } from 'utils/constants';
import { Button } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import { ShopPolygonType } from 'utils/types';

type PolygonCardProps = {
  polygons: ShopPolygonType[];
  setActivePolygon: (polygon: ShopPolygonType) => void;
  list: PolygonItemType[];
  addPolygon?: () => void;
};

const PolygonCard: FC<PolygonCardProps> = ({ polygons, list, setActivePolygon, addPolygon }) => {
  const sortedPolygons = polygons.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className='overflow-y-auto min-w-[100%] rounded-2xl border border-[#EFF0F0]'>
      <div className='flex justify-between items-center border-b border-[#EFF0F0] py-3 px-6'>
        <h2 className='text-sm text-gray-5 uppercase tracking-wider'>Polygons</h2>

        {addPolygon && (
          <Button onClick={addPolygon} small variant='link' color='primary' className='text-xs'>
            <AddIcon /> Add New
          </Button>
        )}
      </div>

      <div className='py-5 px-6 space-y-4 h-[calc(100%-90px)] max-h-[495px] overflow-auto'>
        {sortedPolygons?.map((polygon, index) => (
          <PolygonItem
            list={list}
            onClick={() => setActivePolygon(polygon)}
            key={polygon.id}
            color={POLYGON_COLORS[index % POLYGON_COLORS.length].color_code}
            name={polygon.name}
          />
        ))}
      </div>
    </div>
  );
};

export default PolygonCard;
